// extracted by mini-css-extract-plugin
module.exports = {"familyBannerWrapper":"FamilyBannerWrapper_familyBannerWrapper__oSH6s"};